import { Box } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import Link from 'next/link';
import React from 'react';
import Typography from '@ui/Typography';

export interface CardHeaderProps {
  title: string;
  href?: string;
  slots?: {
    menu?: React.ReactNode;
    icon?: React.ReactNode;
  };
  component?: React.ElementType;
}

const useStyles = makeStyles()(theme => ({
  title: {
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  container: {
    minWidth: '100%',
    display: 'flex',
  },
  root: {
    display: 'grid',
    gridAutoFlow: 'column',
    alignContent: 'center',
    gridTemplateColumns: '1fr',
    gap: theme.spacing(1.5),
    minWidth: '100%',
  },
  iconHeader: {
    display: 'grid',
    gridAutoFlow: 'column',
    alignContent: 'center',
    justifySelf: 'start',
    gap: theme.spacing(1),
    width: '100%',
  },
  link: {
    minWidth: '100%',
    color: 'inherit',
  },
}));

const CardHeader = ({
  title,
  href,
  slots,
  component = 'h3',
}: CardHeaderProps) => {
  const { classes } = useStyles();
  return (
    <Box className={classes.root}>
      <Box
        className={classes.iconHeader}
        gridTemplateColumns={slots?.icon ? '16px 1fr' : '1fr'}
      >
        {slots?.icon}
        <div className={classes.container}>
          <Link href={href || ''} className={classes.link}>
            <Typography
              className={classes.title}
              variant="pMd"
              component={component}
              bold
              noWrap
            >
              {title}
            </Typography>
          </Link>
        </div>
      </Box>
      {slots?.menu}
    </Box>
  );
};

export default CardHeader;
